import styled from 'styled-components';

const BarText = styled.div`
  color: var(--darkGray);
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  margin-bottom: 1rem;
`;

export default BarText;
